import { Table as AntTable } from "antd";
import "react-resizable/css/styles.css";
import { ConfigProvider } from "antd";
import antdTheme from "src/themes/antdTheme";
import {
  attendanceStatuses,
  useMemberAttendances,
} from "src/services/react-query-apis/get-member-attendances";
import { columns } from "../constants/attendance-table-columns";
import { clsx } from "src/utils/clsx";
import { AttendanceEditForm } from "./attendance-edit-form";
import { ReAttendanceForm } from "./re-attendance-form";
import BasicModal from "src/features/student-attendance/components/modal";
import { useState } from "react";
import { QuerySpinner } from "src/components/common/query-spinner";
import { QueryError } from "src/components/common/query-error";
import { BusForm } from "./bus-form";
import moment from "moment";

// update props
const AttendanceTable = ({ studentInfo, date, showInvalid }) => {
  const [modalInfo, setModalInfo] = useState({
    openModal: null,
    attendance: null,
  });

  const memberAttendancesQuery = useMemberAttendances({
    member_id: studentInfo.id,
    start_date: moment(`${date}-01`).startOf("month").format("YYYY-MM-DD"),
    end_date: moment(`${date}-01`).endOf("month").format("YYYY-MM-DD"),
    statuses: attendanceStatuses,
    reschedulable_only: 0,
    bus_only: 0,
    valid_only: 0,
    queryConfig: {
      enabled: !!(studentInfo.id && date),
    },
  });

  if (memberAttendancesQuery.isPending) {
    return <QuerySpinner />;
  }

  if (memberAttendancesQuery.isError) {
    return <QueryError />;
  }

  const onModal = (openModal, attendance) => {
    setModalInfo({
      openModal,
      attendance,
    });
  };

  const handleCancel = () => {
    onModal(null, null);
  };

  return (
    <div className="row p-2" style={{ fontSize: "20px !important" }}>
      <BasicModal
        title="出欠データ変更"
        isOpen={modalInfo.openModal === "attendance"}
        onCancel={handleCancel}
      >
        {modalInfo.attendance && (
          <AttendanceEditForm
            key={modalInfo.attendance.id}
            attendance={modalInfo.attendance}
            onSuccess={handleCancel}
          />
        )}
      </BasicModal>
      <BasicModal
        title="振替"
        isOpen={modalInfo.openModal === "furikae"}
        onCancel={handleCancel}
      >
        {modalInfo.attendance && (
          <ReAttendanceForm
            key={modalInfo.attendance.id}
            attendance={modalInfo.attendance}
            onClose={handleCancel}
          />
        )}
      </BasicModal>
      <BasicModal
        title="バス"
        isOpen={modalInfo.openModal === "bus"}
        onCancel={handleCancel}
      >
        {modalInfo.attendance && (
          <BusForm
            key={modalInfo.attendance.id}
            attendance={modalInfo.attendance}
            onClose={handleCancel}
          />
        )}
      </BasicModal>
      <div className="table-responsive student-attendance-table">
        <ConfigProvider theme={antdTheme}>
          <AntTable
            bordered
            dataSource={memberAttendancesQuery.data}
            columns={columns(onModal)}
            className="mt-4 text-left"
            pagination={false}
            onRow={record => {
              return {
                className: clsx(
                  record.invalid !== 0 && "row-invalid",
                  !showInvalid && record.invalid !== 0 && "d-none"
                ),
              };
            }}
          />
        </ConfigProvider>
      </div>
    </div>
  );
};

export default AttendanceTable;
